import BreadCrumbs from "../../../../../src/components/breadcrumbs/Breadcrumbs";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  BreadCrumbs,
  Playground,
  Props,
  React
};